// import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
// import { ControlValueAccessor, Validator, FormControl } from '@angular/forms';
import { Component, OnInit, Input, Output, forwardRef, EventEmitter, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, Validator } from '@angular/forms';

@Component({
	selector: 'box-selector',
	templateUrl: './box-selector.component.html',
	styleUrls: ['./box-selector.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => BoxSelectorComponent),
			multi: true
		},
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => BoxSelectorComponent),
			multi: true,
		}
	]
})
export class BoxSelectorComponent implements ControlValueAccessor, Validator, OnInit {
	@Input('value') _value: string = '';
	@Input() options: any;
	@Input() selectedOption: any;
	onChange: any = () => { };
	onTouched: any = () => { };
	@Output() selectedOptionChange: EventEmitter<any> = new EventEmitter<any>();
	
	@Output() optionClicked: EventEmitter<any> = new EventEmitter<any>();

	constructor() { }

	ngOnInit() {

	}

	get value() {
		console.log(this.selectedOption);
		return this.selectedOption;
		//return this._value;
	}

	set value(val) {
		this._value = val;
		this.selectedOption = val;
		console.log(this.selectedOption);
		this.onChange(val);
		this.onTouched();
	}

	writeValue(value) {
		if (value) {
			this.value = value;
			//this.setPrefixAndNumber();
		}
	}

	public validate(c: FormControl) {
		return null;
		// return{
		// 	valid: true,
		// };
	}

	registerOnChange(fn) {
		this.onChange = fn;
	}

	registerOnTouched(fn) {
		this.onTouched = fn;
	}

	onSelect(selected) {
		this.selectedOption=selected;
		this.value = selected;
		this.selectedOptionChange.emit(selected);
		this.optionClicked.emit(selected)
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent): void {
		if (event.key === 'Enter') {
			if ((event.target as HTMLElement).dataset.source === 'boxImage') {
				this.onSelect((event.target as HTMLElement).dataset.id);
			}
		}
   	}

}



// WEBPACK FOOTER //
// ./src/app/box-selector/box-selector.component.ts